import { MultiOrderService } from '@spilca/order_ts/v1/order_web/multi_order_web_pb_service';
import { orderRequestConstructor } from '@monorepo/orders';

const getOrdersList = (filter: object | null) =>
  orderRequestConstructor(filter, MultiOrderService.ListMultiOrder);

export default getOrdersList;
